function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.70352 1.51713C2.85325 0.259514 4.606 0.00344411 6.0013 0.748924C7.3966 0.00344411 9.14935 0.259514 10.2991 1.51713C11.6798 3.02743 11.6798 5.4308 10.2991 6.9411C10.2687 6.97438 10.2366 7.0061 10.2029 7.03613L6.88921 9.99412C6.38338 10.4456 5.61923 10.4456 5.11339 9.99412L1.79969 7.03613C1.76604 7.0061 1.73395 6.97438 1.70352 6.9411C0.322785 5.4308 0.322785 3.02743 1.70352 1.51713Z",
  fill: "#262BBA"
});
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.79730f2a161be4f62980145fa8770f45.svg";
export { ForwardRef as ReactComponent };